import { useCallback, useEffect, useRef, useState } from "react";
import { InputWrapper, Input, Wrapper } from "nystem-components";
import app from "nystem";

const UrlimageInput = (props) => {
  const { model } = props;
  const [state, setState] = useState({
    value: props.value,
  });
  const validated = useRef(false);
  const errormsg = model.text_mandatory ? model.text_mandatory : true;

  useEffect(() => {
    if (props.add && model.default) props.setValue(model.id, model.default);
  }, [model, props.add, props.setValue]);

  useEffect(() => {
    if (props.value === state.value) return;
    const error = validated.current && model.mandatory && !props.value;
    setState({
      value: props.value,
      error: error ? errormsg : false,
    });
  }, [errormsg, model.mandatory, props.value, state.value]);

  const handleChange = (value) => {
    validated.current = true;
    setState({
      value: value,
      error: model.mandatory && !value ? errormsg : false,
    });
    props.setValue(model.id, value);
  };

  const valid = useCallback(() => {
    validated.current = true;
    if (model.mandatory && !state.value) {
      setState((oldState) => ({
        ...oldState,
        error: errormsg,
      }));
      return false;
    }
    if (state.error) {
      setState((oldState) => ({ ...oldState, error: false }));
    }
    return true;
  }, [errormsg, model.mandatory, state.error, state.value]);

  useEffect(() => {
    props.model.valid = valid;
  }, [props.model, valid]);

  const clearVal = () => {
    props.setValue(model.id);
  };

  const clearButton = () => {
    if (!model.clearButton || !state.value) return null;
    return (
      <Wrapper
        onClick={clearVal}
        className="fa fa-remove pointer-cursor form-control-feedback"
        aria-hidden="true"
      />
    );
  };

  if (
    model.clearButton &&
    model.className instanceof Array &&
    !model.className.includes("has-feedback")
  )
    model.className.push("has-feedback");

  return (
    <InputWrapper model={model} error={state.error}>
      <Input
        placeholder={app.t(model.text)}
        className="form-control"
        value={state.value || ""}
        maxLength={model.length}
        onChange={handleChange}
        disabled={model.disabled}
        type="text"
        focus={props.focus}
      />
      {clearButton()}
    </InputWrapper>
  );
};
export default UrlimageInput;
